import store from './LightboxStore'
import CrossBtn from './../../assets/appIcons/BTN_Cross.svg';
//import lightboxdir from './LightboxDirective';
import { sync } from 'vuex-pathify'

export default {
  name: 'lightbox',
  components: { CrossBtn },
  props: ['data'],

  data () {
    return {
      state: store.state
      //visible: false

      //url: 'image'

    }
  },
  computed: {
     is_gallery_lightbox:sync('is_gallery_lightbox'),
    log: function() {
      return "computed"
    },
    url () { return this.state.href }
    //console.log(this.state,this.url)

  },
  mounted () {
    console.log("lightbox mounted " + this.state,this.url)
    //url () { return this.state.image }

  },
  methods: {
      restartVideo: function(ref){
        let vid = this.$refs[ref][0] ;
        vid.currentTime = 0;
        vid.play();
      },
      close() {
        this.state.visible = this.is_gallery_lightbox = false;
        // to clear the image, 1x1 transparent gif
        this.state.href = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      }


  }
}
